// PROD
export const BASE_URL = "https://www.ggturismo.com.br/api/";

// // DEV
// export const BASE_URL = 'http://localhost/ggturismo/';

export const URL_BANNERS = "assets/images/banners";
export const URL_PUB = "assets/images/pub";
